import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Row, Col, Card } from "react-bootstrap";
import { SearchInput } from "../../widgets";
import { toDisplayTimeString, secondsToTime } from "../../../helpers/moment-ex";
import { searchWord, isElasticLoad } from "../../../helpers/common";
import LoadingStyle from "../Common/LoadingStyle";
import { getSpeed } from "../../../actions/analyze";
import { TruckSpeedPopover } from "./TruckSpeedPopover";
import { DISPLAY_DATE_FORMAT2 } from "../../../constants";

const TruckList = () => {
  const dispatch = useDispatch();
  const {
    egWiseSpeed,
    selectedWorkTypeIds: activeWorkType,
    egList: { isRequesting: isRequestingEg },
    targetListById: { isRequestingLoad, payload: targetDetailsById },
  } = useSelector((state) => state.dashboard.leaderBoard);
  const speedShortName = useSelector((state) => state.user.settings.speedShortName);
  const search = useSelector((state) => state.analyze.searchParams);
  const [searchText, setSearchText] = useState("");

  const targetDetailList = Object.keys(targetDetailsById).map((id) => targetDetailsById[id]);

  const [egSpeed, setEgSpeed] = useState(null);
  const [openedSpeed, setOpenSpeed] = useState({});
  const [isMultipleDate, setMultipleDate] = useState(false);

  useEffect(() => {
    if (egWiseSpeed) setEgSpeed(egWiseSpeed);
  }, [egWiseSpeed]);

  const filteredList = targetDetailList.filter((e) => (activeWorkType.includes(6) ? 1 : activeWorkType.indexOf(e.workTypeId) >= 0) && searchWord(e.equipmentGroupName, searchText)).sort((a, b) => (a.loadCount === b.loadCount ? (!isElasticLoad() ? a.avgLoadSeconds - b.avgLoadSeconds : a.avgRoundTripSeconds - b.avgRoundTripSeconds) : b.loadCount - a.loadCount));

  const onSpeedClick = (egId) => {
    if (!egId) return;
    if (openedSpeed[egId]) {
      setOpenSpeed({ ...openedSpeed, [egId]: !openedSpeed[egId] });
      return;
    }
    const { custom, range } = search;
    const reqParams = {
      egId,
      range,
      fromDate: custom && custom.from ? custom.from : "",
      toDate: custom && custom.to ? custom.to : "",
      requestFrom: "dashboard",
    };
    setOpenSpeed({ ...openedSpeed, [egId]: true });
    dispatch(getSpeed(reqParams));
  };

  useEffect(() => {
    if (search) {
      const fromDate = moment(search.custom.from).format(DISPLAY_DATE_FORMAT2);
      const toDate = moment(search.custom.to).format(DISPLAY_DATE_FORMAT2);

      if (fromDate === toDate) {
        setMultipleDate(false);
      } else {
        setMultipleDate(true);
      }

      if (search.customRange === "todate" || search.customRange === "planned") {
        setMultipleDate(true);
      }
    }
  }, [search]);

  return (
    <Card className="transport-type">
      <Col className="h-100 p-0">
        <Row className="search-input">
          <SearchInput className="w-100" onChange={(searchText) => setSearchText(searchText)} />
        </Row>
        <Row className="completion-info">
          <Col className="h-100 p-0">
            <Row className="info-header">
              <div className="name" style={{ width: activeWorkType.includes(6) ? "40%" : "33%" }}>
                Transport
              </div>
              <div style={{ width: `${isElasticLoad() ? "32%" : activeWorkType.includes(6) ? "40%" : "15%"}` }}>Loads</div>
              {!activeWorkType.includes(6) && !isElasticLoad() && (
                <>
                  {" "}
                  <div style={{ width: "25%" }}>Avg.Load Time</div> <div style={{ width: `${isElasticLoad() ? "35%" : "27%"}` }}>Avg.Round Trip Time</div>
                </>
              )}
            </Row>
            <Row className={`info-body ${(filteredList.length === 0 || isRequestingEg) && "align-items-center"}`}>
              {isRequestingEg ? (
                <Col className="no-item-found">Loading...</Col>
              ) : filteredList.length === 0 ? (
                <Col className="no-item-found">No Records Found</Col>
              ) : (
                <Col className="p-0">
                  {filteredList.map((item) => (
                    <div key={item.equipmentGroupId}>
                      <div className="eg-card d-flex truck-speed-container">
                        <div className="name d-flex g-2" style={{ width: activeWorkType.includes(6) ? "40%" : "33%" }} title={item.equipmentGroupName}>
                          {!isMultipleDate ? (
                            <div className={`overlay_tooltip`} onClick={() => onSpeedClick(item.equipmentGroupId)}>
                              <TruckSpeedPopover speedShortName={speedShortName} data={egSpeed && egSpeed[item.equipmentGroupId] ? egSpeed[item.equipmentGroupId] : null}></TruckSpeedPopover>
                            </div>
                          ) : null}
                          <div className="transport_eg_name">{item.equipmentGroupName}</div>
                        </div>
                        <div style={{ width: `${isElasticLoad() ? "32%" : activeWorkType.includes(6) ? "40%" : "15%"}` }} className="value">
                          {isRequestingLoad || isRequestingLoad ? <LoadingStyle /> : item.loadCount}
                        </div>
                        {!activeWorkType.includes(6) && !isElasticLoad() && (
                          <>
                            <div style={{ width: "25%" }} className="value">
                              {isRequestingLoad ? <LoadingStyle /> : toDisplayTimeString(secondsToTime(item.avgLoadSeconds, true))}
                            </div>
                            <div style={{ width: `${isElasticLoad() ? "35%" : "27%"}` }} className="value">
                              {isRequestingLoad || isRequestingLoad ? <LoadingStyle /> : toDisplayTimeString(secondsToTime(item.avgRoundTripSeconds, true))}
                            </div>
                          </>
                        )}
                      </div>
                      <div className="divider"></div>
                    </div>
                  ))}
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </Col>
    </Card>
  );
};

export default TruckList;
